/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/member-ordering */
/**
 * Awvent - Business Accounts API
 * Awvent Accounts Apis
 *
 * OpenAPI spec version: v1
 * Contact: djoyrocks@gmail.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';

import { Observable }                                        from 'rxjs';
import { environment }                                        from '../../../../../environments/environment';

import { BusinessAccountAddAddressCommand } from '../model/businessAccountAddAddressCommand';
import { BusinessAccountCreateCommand } from '../model/businessAccountCreateCommand';
import { BusinessAccountDtoIListWebApiPagedResponse } from '../model/businessAccountDtoIListWebApiPagedResponse';
import { BusinessAccountDtoWebApiResponse } from '../model/businessAccountDtoWebApiResponse';
import { BusinessAccountUpdateAddressCommand } from '../model/businessAccountUpdateAddressCommand';
import { BusinessAccountUpdateCommand } from '../model/businessAccountUpdateCommand';
import { BooleanWebApiResponse } from '../../../../shared/common/models/booleanWebApiResponse';

import { Configuration } from '../../../../configuration';
import { BASE_PATH } from '../../../../variables';
import { CustomHttpUrlEncodingCodec } from '../../../../encoder';

@Injectable()
export class BusinessAccountService {

    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    protected basePath = environment.api.businessAccounts;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     *
     *
     * @param id
     * @param xTenantId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessAccountActivateIdPut(id: string, xTenantId: string, observe?: 'body', reportProgress?: boolean): Observable<BusinessAccountDtoWebApiResponse>;
    public businessAccountActivateIdPut(id: string, xTenantId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessAccountDtoWebApiResponse>>;
    public businessAccountActivateIdPut(id: string, xTenantId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessAccountDtoWebApiResponse>>;
    public businessAccountActivateIdPut(id: string, xTenantId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling businessAccountActivateIdPut.');
        }

        if (xTenantId === null || xTenantId === undefined) {
            throw new Error('Required parameter xTenantId was null or undefined when calling businessAccountActivateIdPut.');
        }

        let headers = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<BusinessAccountDtoWebApiResponse>('put',`${this.basePath}/BusinessAccount/Activate/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param xTenantId
     * @param id
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessAccountAddAddressIdPut(xTenantId: string, id: string, body?: BusinessAccountAddAddressCommand, observe?: 'body', reportProgress?: boolean): Observable<BusinessAccountDtoWebApiResponse>;
    public businessAccountAddAddressIdPut(xTenantId: string, id: string, body?: BusinessAccountAddAddressCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessAccountDtoWebApiResponse>>;
    public businessAccountAddAddressIdPut(xTenantId: string, id: string, body?: BusinessAccountAddAddressCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessAccountDtoWebApiResponse>>;
    public businessAccountAddAddressIdPut(xTenantId: string, id: string, body?: BusinessAccountAddAddressCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (xTenantId === null || xTenantId === undefined) {
            throw new Error('Required parameter xTenantId was null or undefined when calling businessAccountAddAddressIdPut.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling businessAccountAddAddressIdPut.');
        }


        let headers = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<BusinessAccountDtoWebApiResponse>('put',`${this.basePath}/BusinessAccount/AddAddress/${encodeURIComponent(String(id))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param id
     * @param xTenantId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessAccountDeactivateIdPut(id: string, xTenantId: string, observe?: 'body', reportProgress?: boolean): Observable<BusinessAccountDtoWebApiResponse>;
    public businessAccountDeactivateIdPut(id: string, xTenantId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessAccountDtoWebApiResponse>>;
    public businessAccountDeactivateIdPut(id: string, xTenantId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessAccountDtoWebApiResponse>>;
    public businessAccountDeactivateIdPut(id: string, xTenantId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling businessAccountDeactivateIdPut.');
        }

        if (xTenantId === null || xTenantId === undefined) {
            throw new Error('Required parameter xTenantId was null or undefined when calling businessAccountDeactivateIdPut.');
        }

        let headers = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<BusinessAccountDtoWebApiResponse>('put',`${this.basePath}/BusinessAccount/Deactivate/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param xTenantId
     * @param isActive
     * @param orderBy
     * @param isOrderByDescending
     * @param searchText
     * @param pageNumber
     * @param pageSize
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessAccountGet(xTenantId: string, isActive?: boolean, orderBy?: Array<string>, isOrderByDescending?: boolean, searchText?: string, pageNumber?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean): Observable<BusinessAccountDtoIListWebApiPagedResponse>;
    public businessAccountGet(xTenantId: string, isActive?: boolean, orderBy?: Array<string>, isOrderByDescending?: boolean, searchText?: string, pageNumber?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessAccountDtoIListWebApiPagedResponse>>;
    public businessAccountGet(xTenantId: string, isActive?: boolean, orderBy?: Array<string>, isOrderByDescending?: boolean, searchText?: string, pageNumber?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessAccountDtoIListWebApiPagedResponse>>;
    public businessAccountGet(xTenantId: string, isActive?: boolean, orderBy?: Array<string>, isOrderByDescending?: boolean, searchText?: string, pageNumber?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (xTenantId === null || xTenantId === undefined) {
            throw new Error('Required parameter xTenantId was null or undefined when calling businessAccountGet.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (isActive !== undefined && isActive !== null) {
            queryParameters = queryParameters.set('IsActive', isActive);
        }
        if (orderBy) {
            orderBy.forEach((element) => {
                queryParameters = queryParameters.append('OrderBy', element);
            });
        }
        if (isOrderByDescending !== undefined && isOrderByDescending !== null) {
            queryParameters = queryParameters.set('IsOrderByDescending', isOrderByDescending);
        }
        if (searchText !== undefined && searchText !== null) {
            queryParameters = queryParameters.set('SearchText', searchText);
        }
        if (pageNumber !== undefined && pageNumber !== null) {
            queryParameters = queryParameters.set('PageNumber', pageNumber);
        }
        if (pageSize !== undefined && pageSize !== null) {
            queryParameters = queryParameters.set('PageSize', pageSize);
        }

        let headers = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<BusinessAccountDtoIListWebApiPagedResponse>('get',`${this.basePath}/BusinessAccount`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param id
     * @param xTenantId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessAccountIdDelete(id: string, xTenantId: string, observe?: 'body', reportProgress?: boolean): Observable<BooleanWebApiResponse>;
    public businessAccountIdDelete(id: string, xTenantId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BooleanWebApiResponse>>;
    public businessAccountIdDelete(id: string, xTenantId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BooleanWebApiResponse>>;
    public businessAccountIdDelete(id: string, xTenantId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling businessAccountIdDelete.');
        }

        if (xTenantId === null || xTenantId === undefined) {
            throw new Error('Required parameter xTenantId was null or undefined when calling businessAccountIdDelete.');
        }

        let headers = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<BooleanWebApiResponse>('delete',`${this.basePath}/BusinessAccount/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param id
     * @param xTenantId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessAccountIdGet(id: string, xTenantId: string, observe?: 'body', reportProgress?: boolean): Observable<BusinessAccountDtoWebApiResponse>;
    public businessAccountIdGet(id: string, xTenantId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessAccountDtoWebApiResponse>>;
    public businessAccountIdGet(id: string, xTenantId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessAccountDtoWebApiResponse>>;
    public businessAccountIdGet(id: string, xTenantId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling businessAccountIdGet.');
        }

        if (xTenantId === null || xTenantId === undefined) {
            throw new Error('Required parameter xTenantId was null or undefined when calling businessAccountIdGet.');
        }

        let headers = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<BusinessAccountDtoWebApiResponse>('get',`${this.basePath}/BusinessAccount/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param xTenantId
     * @param body
     * @param xRequestId
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessAccountPost(xTenantId: string, body?: BusinessAccountCreateCommand, xRequestId?: string, observe?: 'body', reportProgress?: boolean): Observable<BusinessAccountDtoWebApiResponse>;
    public businessAccountPost(xTenantId: string, body?: BusinessAccountCreateCommand, xRequestId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessAccountDtoWebApiResponse>>;
    public businessAccountPost(xTenantId: string, body?: BusinessAccountCreateCommand, xRequestId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessAccountDtoWebApiResponse>>;
    public businessAccountPost(xTenantId: string, body?: BusinessAccountCreateCommand, xRequestId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (xTenantId === null || xTenantId === undefined) {
            throw new Error('Required parameter xTenantId was null or undefined when calling businessAccountPost.');
        }



        let headers = this.defaultHeaders;
        if (xRequestId !== undefined && xRequestId !== null) {
            headers = headers.set('x-request-id', String(xRequestId));
        }
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<BusinessAccountDtoWebApiResponse>('post',`${this.basePath}/BusinessAccount`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param xTenantId
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessAccountPut(xTenantId: string, body?: BusinessAccountUpdateCommand, observe?: 'body', reportProgress?: boolean): Observable<BusinessAccountDtoWebApiResponse>;
    public businessAccountPut(xTenantId: string, body?: BusinessAccountUpdateCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessAccountDtoWebApiResponse>>;
    public businessAccountPut(xTenantId: string, body?: BusinessAccountUpdateCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessAccountDtoWebApiResponse>>;
    public businessAccountPut(xTenantId: string, body?: BusinessAccountUpdateCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (xTenantId === null || xTenantId === undefined) {
            throw new Error('Required parameter xTenantId was null or undefined when calling businessAccountPut.');
        }


        let headers = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<BusinessAccountDtoWebApiResponse>('put',`${this.basePath}/BusinessAccount`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     *
     *
     * @param xTenantId
     * @param id
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessAccountUpdateAddressIdPut(xTenantId: string, id: string, body?: BusinessAccountUpdateAddressCommand, observe?: 'body', reportProgress?: boolean): Observable<BusinessAccountDtoWebApiResponse>;
    public businessAccountUpdateAddressIdPut(xTenantId: string, id: string, body?: BusinessAccountUpdateAddressCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessAccountDtoWebApiResponse>>;
    public businessAccountUpdateAddressIdPut(xTenantId: string, id: string, body?: BusinessAccountUpdateAddressCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessAccountDtoWebApiResponse>>;
    public businessAccountUpdateAddressIdPut(xTenantId: string, id: string, body?: BusinessAccountUpdateAddressCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (xTenantId === null || xTenantId === undefined) {
            throw new Error('Required parameter xTenantId was null or undefined when calling businessAccountUpdateAddressIdPut.');
        }

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling businessAccountUpdateAddressIdPut.');
        }


        let headers = this.defaultHeaders;
        if (xTenantId !== undefined && xTenantId !== null) {
            headers = headers.set('x-tenant-id', String(xTenantId));
        }

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }
        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<BusinessAccountDtoWebApiResponse>('put',`${this.basePath}/BusinessAccount/UpdateAddress/${encodeURIComponent(String(id))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
